import React from "react";
import "./Spinner.css";

const Spinner = ({ visible = false, relative = false }) => {
  if (!visible) return null;

  return (
    <div
      className={`spinner-overlay${relative ? " spinner-overlay-relative" : ""}`}
    >
      <div className="spinner-container">
        <div className="spinner-spinner" />
        <div className="spinner-text">Loading...</div>
      </div>
    </div>
  );
};

export default Spinner;
